var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.9 0h5.2l-0.6 13.8h-4l-0.6-13.8Zm0 18c0-1.4 1.2-2.3 2.6-2.3c1.4 0 2.5 .9 2.5 2.3c0 1.4-1.1 2.3-2.5 2.3c-1.4 0-2.6-0.9-2.6-2.3Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExclamation);
export default __webpack_public_path__ + "static/media/ic_exclamation.490336be6fd82ca67a8ffeb4e0d455a3.svg";
export { ForwardRef as ReactComponent };